import { render, staticRenderFns } from "./FbaRelate.vue?vue&type=template&id=45947a06&scoped=true"
import script from "./FbaRelate.vue?vue&type=script&lang=js"
export * from "./FbaRelate.vue?vue&type=script&lang=js"
import style0 from "./FbaRelate.vue?vue&type=style&index=0&id=45947a06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45947a06",
  null
  
)

export default component.exports